'use client';

import { Box, HStack, VStack } from '@terra/ui-styled-system';
import { Button, Text } from '@terra/ui-design-system';
import { Add01Icon } from '@terra/ui-icons';
import { useDecoderStore } from '../../store/decoder-store';
import { DecoderInput } from './DecoderInput';
import { DecoderStep as DecoderStepComponent } from './DecoderStep';

export function DecoderContent() {
  const steps = useDecoderStore((state) => state.steps);
  const initialInput = useDecoderStore((state) => state.initialInput);
  const selectedOperation = useDecoderStore((state) => state.selectedOperation);
  const addStep = useDecoderStore((state) => state.addStep);
  const handleAddFirstStep = () => {
    addStep({ operation: selectedOperation });
  };

  return (
    <Box h="full" w="full" overflow="auto">
      <Box
        borderWidth="1px"
        borderColor="border.subtle"
        borderRadius="sm"
        overflow="hidden"
        m="2"
      >
        <DecoderInput />
      </Box>

      {steps.length > 0 && (
        <VStack gap={0} mx="2" mb="2" alignItems="stretch">
          {steps.map((step, index) => (
            <Box
              key={step.id}
              borderWidth="1px"
              borderTopWidth={index === 0 ? '1px' : '0'}
              borderColor="border.subtle"
              borderRadius={
                steps.length === 1
                  ? 'sm'
                  : index === 0
                    ? 'sm sm 0 0'
                    : index === steps.length - 1
                      ? '0 0 sm sm'
                      : '0'
              }
              overflow="hidden"
            >
              <DecoderStepComponent step={step} stepNumber={index + 1} />
            </Box>
          ))}
        </VStack>
      )}

      {initialInput && steps.length === 0 && (
        <HStack
          mx="2"
          mb="2"
          px={2}
          py={1}
          bg="bg.muted"
          borderWidth="1px"
          borderColor="border.subtle"
          borderRadius="sm"
          justifyContent="flex-end"
        >
          <Button variant="ghost" size="xs" onClick={handleAddFirstStep}>
            <Add01Icon size={14} />
            Add Step
          </Button>
        </HStack>
      )}

      {!initialInput && steps.length === 0 && (
        <Box textAlign="center" py="8" mx="2" mb="2" color="fg.muted">
          <Text fontSize="xs">
            Paste or type encoded text above to start decoding
          </Text>
        </Box>
      )}
    </Box>
  );
}
